export default __webpack_public_path__ + "static/sample-1d0a139514c997df8a6a571e047cd4a1.pdf";